import "core-js/modules/es.array.map";
import "core-js/modules/es.object.to-string";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import contentView from "../email/components/contentView.vue";
import { versionList, delVersion, sendVersion } from "@/api/gmtool/packageCode";
import addedition from "./components/addedition.vue";
import { gmTool } from "@/mixins/index";
export default {
  name: "edition",
  mixins: [gmTool],
  components: {
    addedition: addedition,
    contentView: contentView
  },
  data: function data() {
    return {
      advanced: false,
      dialog: false,
      paramsData: {
        page: 1,
        version: '',
        channel_id: ''
      },
      total: 0,
      list: [],
      sels: []
    };
  },
  created: function created() {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.getList(1);

            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  methods: {
    getList: function getList(e) {
      var _this2 = this;

      this.reqLoading = true;
      this.paramsData.page = e;
      versionList(this.paramsData).then(function (res) {
        if (res.code == 200) {
          if (!res.data.result.length && _this2.paramsData.page > 1) {
            _this2.getList(_this2.paramsData.page - 1);
          } else {
            _this2.list = res.data.result;
            _this2.total = res.data.total;
          }
        }
      }).finally(function () {
        _this2.reqLoading = false;
      });
    },
    openDetail: function openDetail(data) {
      var listData = JSON.parse(JSON.stringify(data));
      listData.map(function (i) {
        i.language = i.lang;
      });
      this.$refs.contentView.open(listData, 'version');
    },
    // 关闭弹窗
    changeShow: function changeShow(val) {
      this.dialog = val;
    },
    handleSelectionChange: function handleSelectionChange(val) {
      this.sels = val.map(function (i) {
        return i.id;
      });
    },
    sendEdition: function sendEdition(id) {
      var _this3 = this;

      this.$confirm(this.$t('confirmSendVersion'), this.$t('tip'), {
        confirmButtonText: this.$t('confirm'),
        cancelButtonText: this.$t('cancel'),
        type: "warning"
      }).then( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                sendVersion({
                  id: id,
                  is_prod: _this3.paramsData.is_prod
                }).then(function (res) {
                  if (res.code == 200) {
                    _this3.$message({
                      type: "success",
                      message: _this3.$t('sendSuccess')
                    });

                    _this3.getList(1);
                  }
                });

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      })));
    },
    // 删除配置
    handleDelete: function handleDelete(id) {
      var _this4 = this;

      this.$confirm(this.$t('confirmOperation'), this.$t('tip'), {
        confirmButtonText: this.$t('confirm'),
        cancelButtonText: this.$t('cancel'),
        type: "warning"
      }).then( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                delVersion({
                  id: id,
                  is_prod: _this4.paramsData.is_prod
                }).then(function (res) {
                  if (res.code == 200) {
                    _this4.$message({
                      type: "success",
                      message: _this4.$t('deleteSuccess')
                    });

                    _this4.getList(_this4.paramsData.page);
                  }
                });

              case 1:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      })));
    }
  }
};